import { z } from "zod";

export const membershipEventSchema = z
  .object({
    action: z.string(),
    label: z.string(),
    type: z.string(),
  })
  .strict();

export default membershipEventSchema;

export type MembershipEventPayload = z.infer<typeof membershipEventSchema>;
